import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const BillsPageContent = lazy(() => import("./BillsPageContent"));

function BillsPageInternal() {
    return (
        <DefaultPage>
            <BillsPageContent />
        </DefaultPage>
    );
}

export const BillsPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(BillsPageInternal);
